import { UserMetadata } from "firebase/auth";
import { Timestamp } from "firebase/firestore";
import CodingAnimation from "../../assets/coding.json";
import EducationAnimation from "../../assets/education.json";
import FormAnimation from "../../assets/form.json";
import LinkedInAnimation from "../../assets/linkedin.json";
import RecommendersAnimation from "../../assets/recommnders.json";
export interface UserInfo {
    name: string;
    phone: string;
    city: string;
    area?: string;
    email: string;
    title: string;
    metadata: UserMetadata;
    experience: UserExperience[];
    skills: UserSkill[];
    skillsNames: string[];
    field: UserField | "";
    education: UserEducation[];
    skillsTestLink?: string;
    recommenders?: Recommender[];
    social?: Social[];
    personality: Record<string, UserPersonality>;
    // approved?: boolean;
    experienceYears: number;
    degrees?: UserDegree[];
    testGrade: number;
    largeCompanies: boolean;
    largeCompaniesDocument?: string;
    startup: boolean;
    startupDocument?: string;
    management: boolean;
    managementDocument?: string;
    description: string;
    salary: string;
    age: number | null;
    car: boolean;
    notifyOnAllJobs: boolean;
    ides: string[];
    profileViews: number;
}

export enum UserProfileStep {
    PersonalDetails = "Personal Details",
    EducationAndExperience = "Education & Experience",
    Recommenders = "Recommenders",
    SocialAccounts = "Social Accounts",
    PersonalityQuiz = "Personality Quiz",
    SkillsTest = "Development Skills"
}

export const UserProfileParts = [
    {
        label: UserProfileStep.PersonalDetails,
        description: `Your name, email, phone number and address`,
        animation: FormAnimation
    },
    {
        label: UserProfileStep.EducationAndExperience,
        description: 'Your education degrees and work experience',
        // subDescription: "(must provide verifying documents)",
        animation: EducationAnimation
    },
    {
        label: UserProfileStep.SkillsTest,
        description: `Languages and IDEs`,
        animation: CodingAnimation
    },
    
    {
        label: UserProfileStep.SocialAccounts,
        description: `Links to your development social accounts`,
        animation: LinkedInAnimation
    },
    {
        label: UserProfileStep.Recommenders,
        description: `Your recommenders contact information`,
        animation: RecommendersAnimation
    },
   
    // {
    //     label: UserProfileStep.PersonalityQuiz,
    //     description: `A personality quiz`,
    //     animation: IdeaLampAnimation
    // },
];

export interface UserExperience {
    companyName: string;
    fromYear: number;
    toYear: number;
    document: string | null;
    status: UserStatus;
    role: string;
    startup: boolean;
    management: boolean;
}

export interface UserEducation {
    degree: UserDegree,
    school: string;
    fromYear: number;
    toYear: number;
    document: string | null;
    grade: number;
    status: UserStatus;
}

export interface UserSkill {
    skill: string;
    status: UserStatus;
    level: SkillExperience,
    years: number;
}

export enum SkillExperience {
    Beginner = 1,
    Advanced,
    Expert,
}

export const SkillExperienceLabels = {
    [SkillExperience.Beginner]: "Beginner",
    [SkillExperience.Advanced]: "Advanced",
    [SkillExperience.Expert]: "Expert",
}

export const RatingLabels: { [index: string]: string } = {
    1: 'Strongly Disagree',
    2: 'Disagree',
    3: 'Neutral',
    4: 'Agree',
    5: 'Strongly Agree',
};

export enum UserDegree {
    Student = "Student",
    BSC = "B.Sc. - Bachelor of Science",
    MSC = "M.Sc. - Master of Science",
    DSC = "D.Sc. - Doctor of Science",
    BachelorsDegree = "Bachelor's Degree",
    MastersDegree = "Master's Degree",
    DoctorsDegree = "Doctor's Degree",
}

export enum Areas {
    TelAviv = "Tel Aviv",
    Jerusalem = "Jerusalem",
    Haifa = "Haifa",
    North = "North",
    BeerSheva = "Be`er Sheva",
    South = "South"
}

export enum UserField {
    Backend = "Backend",
    Frontend = 'Frontend',
    DBA = "DBA",
    Network = "Network",
    Cyber = "Cyber",
    FullStack = "FullStack",
    QA = "QA",

}

export enum UserStatus {
    Pending = "Pending",
    Verified = "Verified",
    NotVerified = "Not Verified"
}

export interface Recommender {
    name: string;
    role: string;
    email: string;
    recommendation?: string;
    status: UserStatus;
    phone: string;
}

export interface Social {
    link: string;
    status: UserStatus;
}

export enum PersonalityQuestion {
    MultiTasking = "MultiTasking",
    LongDay = "LongDay",
    Professional = "Professional",
    Quick = "Quick",
    Collaborating = "Collaborating"
}

export const PersonalityQuestionTitles = {
    [PersonalityQuestion.MultiTasking]: "Multi tasking",
    [PersonalityQuestion.LongDay]: "Working till late",
    [PersonalityQuestion.Professional]: "Professional",
    [PersonalityQuestion.Quick]: "Thorough and quick work",
    [PersonalityQuestion.Collaborating]: "Collaboration",
}

export interface UserPersonality {
    type: PersonalityQuestion;
    rating: number | null;
}

export const PersonalityQuestionDetails = [
    {
        type: PersonalityQuestion.MultiTasking,
        question: "You regularly make new friends.",
    },
    {
        type: PersonalityQuestion.LongDay,
        question: "You spend a lot of your free time exploring various random topics that pique your interest.",
        revert: false
    },
    {
        type: PersonalityQuestion.Quick,
        question: "Seeing other people cry can easily make you feel like you want to cry too.",
        // revert: true
    },
    {
        type: PersonalityQuestion.Professional,
        question: "You often make a backup plan for a backup plan.",
        // revert: true
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You usually stay calm, even under a lot of pressure.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "At social events, you rarely try to introduce yourself to new people and mostly talk to the ones you already know.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You prefer to completely finish one project before starting another.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You are very sentimental.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You like to use organizing tools like schedules and lists.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "Even a small mistake can cause you to doubt your overall abilities and knowledge.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You feel comfortable just walking up to someone you find interesting and striking up a conversation.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You are not too interested in discussing various interpretations and analyses of creative works.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You usually prefer just doing what you feel like at any given moment instead of planning a particular daily routine.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You rarely worry about whether you make a good impression on people you meet.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You enjoy participating in group activities.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You like books that make you come up with your own interpretation of the ending.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "Your happiness comes more from helping others accomplish things than your own accomplishments.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You are interested in so many things that you find it difficult to choose what to try next.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You are prone to worrying that things will take a turn for the worse.",
        // revert: true,
    },
    {
        type: PersonalityQuestion.Collaborating,
        question: "You avoid leadership roles in group settings.",
        // revert: true,
    },

]

export interface UserJob {
    email: string;
    name: string;
    status: JobStatus;
    company: string;
    firstInterviewDate?: Timestamp;
    secondInterviewDate?: Timestamp;
    employerSecondInterviewDates?: Timestamp[];
    place: string;
}

export enum JobStatus {
    Examined = "Examined",
    // InProcess = "In Process",
    FirstVideoInterview = "Video Interview",
    FrontalInterview = "Frontal Interview",
    Accepted = "Accepted"
}

export enum PersonalTabs {
    Personal,
    Description,
    // Salary,
}